import * as R from 'ramda';

export const equals = R.curry((a: any, b: any) => a === b);

export const isEmpty = (object: any) => object == null || Object.keys(object).length === 0;

export const parse = (value: string) => (value == null) ? null : JSON.parse(value);
